// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ctx-menu-container {
	border: 0;
}
.ctx-menu {
	position: absolute;
	width: auto;
	z-index: 999;
	list-style: none;
	margin: 0;
	padding: 0;
}
.ctx-menu > li {
	padding: 0.25rem 0.75rem;
	box-sizing: border-box;
	cursor: hand;
	cursor: pointer;
	white-space: nowrap;
}
.ctx-menu > li:hover {
	text-decoration: none;
	background-color: var(--bs-secondary-bg-subtle);
}
.ctx-menu > hr {
	margin: 0
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
